import axios from 'axios'

import type { ImageFile } from '@/types/types'
import type { WebappSocials } from '@/views/loyaltySupports/webapp/lib/brandAppHomeApi'

export default function useWebapp() {
  const getWebapp = async () => {
    try {
      const { data: dataWebapp } = await axios.get('/webapps')
      return dataWebapp.data
    } catch (error) {
      console.error(error)
    }
  }

  const saveWebapp = async ({
    color,
    image,
    hasFormCompletion,
    hasCustomerStatus,
    statusSegmentIds,
    home,
    colors,
    tabs,
    socials,
    completionFields,
    loyaltyBlocks,
    id
  }: {
    color?: string
    image?: ImageFile
    hasFormCompletion?: boolean
    hasCustomerStatus?: boolean
    statusSegmentIds?: number[]
    home?: { heroImage: string | null; homeBlocks: string[]; homeBlockTitles: Record<string, string> }
    colors?: { buttonColor: string | null; textColor: string | null }
    tabs?: string[]
    socials?: WebappSocials
    completionFields?: string[]
    loyaltyBlocks?: string[]
    id?: number
  }) => {
    const payload: {
      color: string
      hasFormCompletion?: boolean
      hasCustomerStatus?: boolean
      statusSegmentIds?: number[]
      images?: string[]
      heroImage?: string | null
      homeBlocks?: string[]
      homeBlockTitles?: Record<string, string>
      buttonColor?: string | null
      textColor?: string | null
      tabs?: string[]
      socials?: WebappSocials
      completionFields?: string[]
      loyaltyBlocks?: string[]
    } = {
      color: color.replace('#', ''),
      ...home,
      ...colors,
      ...(tabs ? { tabs } : {}),
      ...(socials ? { socials } : {}),
      ...(completionFields ? { completionFields } : {}),
      ...(loyaltyBlocks ? { loyaltyBlocks } : {})
    }

    let webappId = id
    if (!id) {
      const { data: dataWebapp } = await axios.get('/webapps')
      webappId = dataWebapp.data.id
    }

    if (hasFormCompletion !== undefined) payload.hasFormCompletion = hasFormCompletion
    if (hasCustomerStatus !== undefined) payload.hasCustomerStatus = hasCustomerStatus
    if (statusSegmentIds !== undefined) payload.statusSegmentIds = statusSegmentIds
    if (image) payload.images = [image.path]

    return await axios.put(`/webapps/${webappId}`, payload)
  }

  return { getWebapp, saveWebapp }
}
